export { default } from "./QuickButtons";
